"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Register = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var RegisterStore = require("../store/Register");
var kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
var EventInfo_Registrants_1 = require("./EventInfo_Registrants");
var Footer_1 = require("./Footer");
var AdditionalRegistrants_1 = require("./AdditionalRegistrants");
var serialize = function (obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
};
var loadingPanel = (React.createElement("div", { className: "k-loading-mask" },
    React.createElement("div", { className: "k-loading-image" },
        React.createElement("div", { className: "k-loadingtext", role: 'alert', "aria-label": 'Progressing' })),
    React.createElement("div", { className: "k-loading-color" })));
//const rules = {
//    0: /[023456789]/
//};
var Register = /** @class */ (function (_super) {
    __extends(Register, _super);
    function Register(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            ddRegistrantTypes: [], ddDegree: [], ddlSpecialty: [], ddlMeetingSource: [], ddlState: [], guests: '', Registerdisplay: 'block', Registerbuttonclass: 'link-button6', ShowLoader: false
        };
        fetch('api/ListItems/RegistrantType')
            .then(function (response) { return response.json(); })
            .then(function (list) {
            _this.setState({ ddRegistrantTypes: list });
        }).catch(function (error) {
            console.log(error);
        });
        fetch('api/ListItems/Degree')
            .then(function (response) { return response.json(); })
            .then(function (list) {
            _this.setState({ ddDegree: list });
        }).catch(function (error) {
            console.log(error);
        });
        fetch('api/ListItems/Specialty')
            .then(function (response) { return response.json(); })
            .then(function (list) {
            _this.setState({ ddlSpecialty: list });
        }).catch(function (error) {
            console.log(error);
        });
        fetch('api/ListItems/MeetingSource')
            .then(function (response) { return response.json(); })
            .then(function (list) {
            _this.setState({ ddlMeetingSource: list });
        }).catch(function (error) {
            console.log(error);
        });
        fetch('api/ListItems/State')
            .then(function (response) { return response.json(); })
            .then(function (list) {
            _this.setState({ ddlState: list });
        }).catch(function (error) {
            console.log(error);
        });
        var accesscode = _this.props.match.params.ac;
        if (accesscode !== "" && accesscode !== undefined) {
            var queryStr = serialize({ sAccessCode: accesscode });
            var base_url = 'api/Registration/ValidateAccessCode';
            var init = { method: 'POST', accept: 'application/json', headers: {} };
            fetch(base_url + "?" + queryStr, init).then(function (response) { return response.json(); })
                .then(function (result) {
                if (result == "-1" || result == "0") {
                    _this.props.history.push("/");
                }
                else if (result.EventId !== "" && !result.IsPastEvent && result.IsRegistrationAllowed) {
                    _this.props.setEventID(result.EventId);
                }
                else if (result.IsPastEvent) {
                    _this.props.setEventID(result.EventId);
                    _this.setState({ Registerdisplay: 'none' });
                }
                else if (!result.IsRegistrationAllowed) {
                    _this.setState({ Registerbuttonclass: 'link-button6-grey-disabled' });
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
        // This binding is necessary to make "this" work in the callback
        _this.handleSave = _this.handleSave.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleDegreeOther = _this.handleDegreeOther.bind(_this);
        _this.handleSpecialtyOther = _this.handleSpecialtyOther.bind(_this);
        _this.handleMeetingOther = _this.handleMeetingOther.bind(_this);
        return _this;
    }
    Register.prototype.componentDidMount = function () {
        var divISI = document.getElementById('fixed-isi');
        if (divISI != null) {
            divISI.classList.remove('active');
            divISI.classList.add('isi-top-inactive');
        }
        var divRegisterContainer = document.getElementById('registerContainer');
        if (divISI != null && divRegisterContainer != null) {
            if (!divISI.classList.contains('isi-top-inactive')) {
                divRegisterContainer.classList.add('regContainerWithISI');
                divRegisterContainer.classList.remove('regContainerWithoutISI');
                divISI.style.top = "calc(100% - 32px)";
            }
            else {
                divRegisterContainer.classList.remove('regContainerWithtISI');
                divRegisterContainer.classList.add('regContainerWithoutISI');
            }
        }
        //Add custom attribute for number keypad with mobile devices
        //Phone
        var varPhone = document.getElementById("mtPhone");
        if (varPhone != null) {
            var attPhone = document.createAttribute("inputmode");
            attPhone.value = "numeric";
            varPhone.setAttributeNode(attPhone);
            varPhone.setAttribute("aria-label", "phonenumber");
        }
        //Mobile
        var varMobile = document.getElementById("mtMobile");
        if (varMobile != null) {
            var attMobile = document.createAttribute("inputmode");
            attMobile.value = "numeric";
            varMobile.setAttributeNode(attMobile);
            varMobile.setAttribute("aria-label", "mobilenumber");
        }
        //Zipcode
        var varZipcode = document.getElementById("mtZipcode");
        if (varZipcode != null) {
            var attZipcode = document.createAttribute("inputmode");
            attZipcode.value = "numeric";
            varZipcode.setAttributeNode(attZipcode);
            varZipcode.setAttribute("aria-label", "zipcode");
        }
        //NPI Number
        var varNPINumber = document.getElementById("txtNPINumber");
        if (varNPINumber != null) {
            var attNPINumber = document.createAttribute("inputmode");
            attNPINumber.value = "numeric";
            varNPINumber.setAttributeNode(attNPINumber);
        }
    };
    Register.prototype.render = function () {
        var contents = this.renderCreateForm();
        return React.createElement("div", null, contents);
    };
    Register.prototype.handleDegreeOther = function (e) {
        var tdDegreeOther = document.getElementById('tdDegreeOther');
        var inDegreeOther = document.getElementById('txtDegreeOther');
        if (tdDegreeOther != null) {
            if (e.target.value == 'Other') {
                tdDegreeOther.style.display = "block";
                if (inDegreeOther != null)
                    inDegreeOther.setAttribute("required", "");
            }
            else {
                tdDegreeOther.style.display = "none";
                if (inDegreeOther != null)
                    inDegreeOther.removeAttribute("required");
            }
        }
    };
    Register.prototype.handleSpecialtyOther = function (e) {
        var tdSpecialtyOther = document.getElementById('tdSpecialtyOther');
        var inSpecialtyOther = document.getElementById('txtSpecialtyOther');
        if (tdSpecialtyOther != null) {
            if (e.target.value == 'Other') {
                tdSpecialtyOther.style.display = "block";
                if (inSpecialtyOther != null)
                    inSpecialtyOther.setAttribute("required", "");
            }
            else {
                tdSpecialtyOther.style.display = "none";
                if (inSpecialtyOther != null)
                    inSpecialtyOther.removeAttribute("required");
            }
        }
    };
    Register.prototype.handleMeetingOther = function (e) {
        var tdMeetingSourceOther = document.getElementById('tdMeetingSourceOther');
        var inMeetingSourceOther = document.getElementById('txtMeetingSourceOther');
        if (tdMeetingSourceOther != null) {
            if (e.target.value == 'Other') {
                tdMeetingSourceOther.style.display = "block";
                if (inMeetingSourceOther != null)
                    inMeetingSourceOther.setAttribute("required", "");
            }
            else {
                tdMeetingSourceOther.style.display = "none";
                if (inMeetingSourceOther != null)
                    inMeetingSourceOther.removeAttribute("required");
            }
        }
    };
    // This will handle the submit form event.
    Register.prototype.handleSave = function (event) {
        var _this = this;
        event.preventDefault();
        var data = new FormData(event.target);
        this.setState({ ShowLoader: true });
        fetch('api/Registration/Register', {
            method: 'POST',
            body: data,
        }).then(function (response) { return response.text(); })
            .then(function (confirmationCode) {
            if (confirmationCode !== "-1") {
                _this.props.setConfirmationCode(confirmationCode);
                _this.setState({ ShowLoader: false });
                _this.props.history.push("/receipt");
            }
        }).catch(function (error) {
            _this.setState({ ShowLoader: false });
            console.log(error);
        });
    };
    // This will handle Cancel button click event.
    Register.prototype.handleCancel = function (e) {
        e.preventDefault();
        this.props.history.push("/");
    };
    // Returns the HTML Form to the render() method.
    Register.prototype.renderCreateForm = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("form", { onSubmit: this.handleSave },
                React.createElement("div", { id: "registerContainer" },
                    React.createElement("div", { className: "Register-Container", id: "registerContainer-inner" },
                        React.createElement("div", null,
                            React.createElement(EventInfo_Registrants_1.default, null)),
                        React.createElement("div", { className: "Register-Wrapper", style: { display: this.state.Registerdisplay } },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("h3", { className: "h2Title" }, "Registrant Information"))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "First Name:"),
                                    React.createElement("input", { type: "text", name: "firstname", "aria-label": "firstname", className: "fieldcontrol1", required: true })),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "Last Name:"),
                                    React.createElement("input", { type: "text", name: "lastname", "aria-label": "lastname", className: "fieldcontrol1", required: true })),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("div", { style: { display: "flex" } },
                                        React.createElement("div", { style: { width: "100px", verticalAlign: "top" } },
                                            React.createElement("span", { className: "fieldlabel1" }, "Middle Name:"),
                                            React.createElement("div", null,
                                                React.createElement("input", { type: "text", name: "middlename", "aria-label": "middlename", style: { width: "75px" } }))),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "required" }, "*"),
                                            React.createElement("span", { className: "fieldlabel1" }, "Degree:"),
                                            React.createElement("div", null,
                                                React.createElement("select", { "data-val": "true", name: "Degree", "aria-label": "degree", style: { width: "110px" }, onChange: this.handleDegreeOther, required: true }, this.state.ddDegree.map(function (degree) {
                                                    return React.createElement("option", { key: degree.itemValue, value: degree.itemValue }, degree.itemText);
                                                }))),
                                            React.createElement("div", null,
                                                React.createElement("div", { id: "tdDegreeOther", style: { paddingTop: "10px", display: "none" } },
                                                    React.createElement("input", { type: "text", id: "txtDegreeOther", name: "degreeother", "aria-label": "degreeother", className: "fieldcontrol1", style: { width: "90px" } }))))))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "Email:"),
                                    React.createElement("input", { type: "email", name: "email", "aria-label": "email", className: "fieldcontrol1", required: true })),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "Phone Number:"),
                                    React.createElement("div", null,
                                        React.createElement(kendo_react_inputs_1.MaskedTextBox, { mask: "(###) ###-####", id: "mtPhone", name: "phone", width: "200px", required: true }))),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "fieldlabel1" }, "Mobile Phone Number:"),
                                    React.createElement("div", null,
                                        React.createElement(kendo_react_inputs_1.MaskedTextBox, { mask: "(###) ###-####", name: "mobile", width: "200px", id: "mtMobile" })),
                                    React.createElement("br", null),
                                    React.createElement("span", { style: { fontSize: "12px", color: "#666666", fontStyle: "italic" } }, "By providing your mobile number, you agree to receive a text reminder for this program. Standard text message rates may apply."))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("h3", { className: "h2Title" }, "Professional Information"))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "Registrant Type:"),
                                    React.createElement("select", { "data-val": "true", name: "RegistrantType", "aria-label": "registrantType", className: "fieldcontrol1", required: true }, this.state.ddRegistrantTypes.map(function (registrantType) {
                                        return React.createElement("option", { key: registrantType.itemValue, value: registrantType.itemValue }, registrantType.itemText);
                                    })))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "Title:"),
                                    React.createElement("input", { type: "text", name: "jobtitle", "aria-label": "title", className: "fieldcontrol1", required: true })),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "Specialty:"),
                                    React.createElement("select", { "data-val": "true", name: "specialty", "aria-label": "specialty", className: "fieldcontrol1", onChange: this.handleSpecialtyOther, required: true }, this.state.ddlSpecialty.map(function (specialty) {
                                        return React.createElement("option", { key: specialty.itemValue, value: specialty.itemValue }, specialty.itemText);
                                    })),
                                    React.createElement("div", null,
                                        React.createElement("div", { id: "tdSpecialtyOther", style: { paddingTop: "10px", display: "none" } },
                                            React.createElement("input", { id: "txtSpecialtyOther", type: "text", name: "specialtyother", "aria-label": "specialtyother", className: "fieldcontrol1" })))),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "fieldlabel1" }, "NPI Number:"),
                                    React.createElement("div", null,
                                        React.createElement("input", { name: "npinumber", "aria-label": "npinumber", id: "txtNPINumber", className: "fieldcontrol1", maxLength: 5, type: "number" })))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "Affiliation/Company:"),
                                    React.createElement("div", null,
                                        React.createElement("input", { type: "text", name: "company", "aria-label": "affiliation/company", className: "fieldcontrol1", required: true })))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "Address1:"),
                                    React.createElement("input", { type: "text", name: "address1", "aria-label": "address1", className: "fieldcontrol1", required: true })),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "fieldlabel1" }, "Address2:"),
                                    React.createElement("input", { type: "text", name: "address2", "aria-label": "address2", className: "fieldcontrol1" })),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "City:"),
                                    React.createElement("input", { type: "text", name: "city", "aria-label": "city", className: "fieldcontrol1", required: true }))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "State:"),
                                    React.createElement("select", { "data-val": "true", name: "state", "aria-label": "state", className: "fieldcontrol1", required: true }, this.state.ddlState.map(function (state) {
                                        return React.createElement("option", { key: state.itemValue, value: state.itemValue }, state.itemText);
                                    }))),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "Zip Code:"),
                                    React.createElement("div", null,
                                        React.createElement(kendo_react_inputs_1.MaskedTextBox, { mask: "#####", name: "zipcode", className: "fieldcontrol1", required: true, id: "mtZipcode" })))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { className: "required" }, "*"),
                                    React.createElement("span", { className: "fieldlabel1" }, "How did you hear about the program?"),
                                    React.createElement("div", null,
                                        React.createElement("select", { "data-val": "true", name: "meetingsource", "aria-label": "meetingsource", className: "fieldcontrol1", onChange: this.handleMeetingOther, required: true }, this.state.ddlMeetingSource.map(function (meetingsource) {
                                            return React.createElement("option", { key: meetingsource.itemValue, value: meetingsource.itemValue }, meetingsource.itemText);
                                        })),
                                        React.createElement("div", null,
                                            React.createElement("div", { id: "tdMeetingSourceOther", style: { paddingTop: "10px", display: "none" } },
                                                React.createElement("input", { id: "txtMeetingSourceOther", type: "text", name: "meetingsourceother", "aria-label": "meetingsourceother", className: "fieldcontrol1" })))))),
                            React.createElement("div", { className: "row", style: { display: "none" } },
                                React.createElement("div", { style: { float: "left", padding: "5px", marginLeft: "20px" } },
                                    React.createElement("div", null,
                                        React.createElement(AdditionalRegistrants_1.default, { onSelectGuests: function (value) { return _this.setState({ guests: value }); } })))),
                            React.createElement("div", { style: { color: "#666666", backgroundColor: "#F9F9F9", padding: "20px 20px 20px 0px" } },
                                React.createElement("div", { style: { fontStyle: "13px" } },
                                    React.createElement("div", null,
                                        React.createElement("p", { style: { marginTop: "0px", paddingLeft: "10px" } }, "By submitting this form, I certify that I am a US resident 18 years of age or older and agree to receiving further communications from BioCryst. I understand that any personally identifying information I provide will be used and protected in accordance with the Terms of Use and Privacy Policy."))),
                                React.createElement("div", { style: { textAlign: "center", padding: "10px" } },
                                    React.createElement("span", { style: { fontStyle: "italic", textAlign: "center" } },
                                        React.createElement("span", { className: "required" }, "*"),
                                        "Required field (Enter N/A if not applicable)")),
                                this.state.ShowLoader && loadingPanel,
                                React.createElement("div", { style: { textAlign: "center" } },
                                    React.createElement("div", null,
                                        React.createElement("button", { type: "submit", className: this.state.Registerbuttonclass }, "Register"),
                                        "\u00A0",
                                        React.createElement("button", { className: "link-button6-grey", onClick: this.handleCancel }, "Cancel"))),
                                React.createElement("input", { type: "hidden", name: "eventId", value: this.props.eventId }),
                                React.createElement("input", { type: "hidden", name: "guestslist", value: this.state.guests }),
                                React.createElement("div", null))),
                        React.createElement("div", { id: "divEventErrorPastDate", style: { display: this.state.Registerdisplay == 'block' ? 'none' : 'block', paddingTop: "60px", textAlign: "center", height: "211px" } },
                            React.createElement("h2", { style: { color: "black" } }, "This Meeting is not accepting registrations at this time."),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            "Thank you.")),
                    React.createElement("div", null,
                        React.createElement(Footer_1.default, null))))));
    };
    return Register;
}(React.PureComponent));
exports.Register = Register;
;
exports.default = react_redux_1.connect(function (state) { return state.register; }, RegisterStore.actionCreators)(Register);
//# sourceMappingURL=Register.js.map